// Native details handle Enter, Space and hide closed descendants from focus.
// The module is used by both header variants; install global handlers once.
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const active = document.activeElement;
  const menu = active?.closest('[data-ps-navigation][open]');
  if (!menu) return;
  menu.querySelectorAll('[data-ps-navigation][open]').forEach(child => { child.open = false; });
  menu.open = false;
  menu.querySelector('summary')?.focus();
  event.preventDefault();
});
document.addEventListener('click', (event) => {
  for (const menu of document.querySelectorAll('[data-ps-navigation][open]')) {
    if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
  }
});
